import { useMemo } from 'react'
import { AlertCircle, Fuel } from 'lucide-react'
import MetricCards from '../components/dashboard/MetricCards'
import BranchCard from '../components/dashboard/BranchCard'
import { getVisibleBranches } from '../utils/dataHelpers'
import { formatNaira } from '../utils/formatters'

const TODAY_FILTERS = { dateFilter: 'today', fuelTypeFilter: 'all', selectedOrg: 'all', selectedBranch: 'all', customRange: { start: '', end: '' } }

function greeting() {
  const h = new Date().getHours()
  if (h < 12) return 'Good morning'
  if (h < 17) return 'Good afternoon'
  return 'Good evening'
}

export default function HomePage({ currentUser, organizations, branches, entries, expenses, onEnterData, onEditEntry, onDeleteEntry, getCreditTodaySummary, getCreditTodaySummaryForOrg }) {
  const visibleBranches = getVisibleBranches(currentUser, branches, TODAY_FILTERS)
  const firstName = currentUser.name.split(' ')[0]
  const todayLabel = useMemo(() => new Date().toLocaleDateString('en-NG', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' }), [])
  const creditSummary = useMemo(() => {
    if (currentUser.branchId && getCreditTodaySummary) return getCreditTodaySummary(currentUser.branchId)
    if (getCreditTodaySummaryForOrg) return getCreditTodaySummaryForOrg()
    return null
  }, [currentUser.branchId, getCreditTodaySummary, getCreditTodaySummaryForOrg])

  return (
    <div className="animate-fadeIn space-y-4 sm:space-y-6">
      <div className="bg-gradient-to-r from-blue-600 to-blue-700 rounded-2xl p-4 sm:p-5 text-white">
        <p className="text-blue-100 text-sm mb-1">{todayLabel}</p>
        <h1 className="text-xl sm:text-2xl font-bold">{greeting()}, {firstName} 👋</h1>
        <p className="text-blue-200 text-sm mt-0.5 capitalize">{currentUser.role}</p>
      </div>

      {creditSummary && creditSummary.count > 0 && (
        <div className="bg-white rounded-xl border border-gray-100 shadow-sm px-4 py-3 flex items-center space-x-3">
          <div className="w-9 h-9 bg-amber-100 rounded-xl flex items-center justify-center flex-shrink-0"><Fuel className="w-4.5 h-4.5 text-amber-600" /></div>
          <div className="flex-1 min-w-0">
            <p className="text-xs text-gray-500 font-medium">Credit Sales Today</p>
            <p className="text-sm font-bold text-gray-800">{creditSummary.count} sale{creditSummary.count !== 1 ? 's' : ''} · {creditSummary.litres.toLocaleString('en-NG')} L</p>
          </div>
          <p className="text-sm font-bold text-amber-700 flex-shrink-0">{formatNaira(creditSummary.value)}</p>
        </div>
      )}

      <MetricCards currentUser={currentUser} filters={TODAY_FILTERS} branches={branches} entries={entries} expenses={expenses} />

      <div>
        <h2 className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-3">Today's Activity</h2>
        {visibleBranches.length === 0 ? (
          <div className="bg-white rounded-xl shadow p-8 text-center"><AlertCircle className="w-12 h-12 text-gray-200 mx-auto mb-3" /><p className="text-gray-500 font-medium">No branches found</p></div>
        ) : (
          <div className="space-y-4">
            {visibleBranches.map((branch) => (
              <BranchCard key={branch.id} branch={branch} organization={organizations.find((o) => o.id === branch.organizationId)}
                entries={entries} expenses={expenses} filters={TODAY_FILTERS} currentUser={currentUser}
                onEnterData={onEnterData} onEditEntry={onEditEntry} onDeleteEntry={onDeleteEntry} />
            ))}
          </div>
        )}
      </div>
    </div>
  )
}
